<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
			<Button type="primary" @click="add()">新增</Button>
		</div>
		<div class="query">
			<div class="checkbox">

			</div>
			<!-- <Input search enter-button placeholder="请输入地址/名称查询" style="width: 500px;" /> -->
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="examine(row)">查看素材</Button>
				<Modal v-model="modal1"  title="轮播图" width='70' class="lunbo">
					<img v-for="item in imgUrls" :key="item" :src="item" class="lunbo-img"/>
				</Modal>
				<Modal v-model="modal2"  width='70' title="短视频">
					<Video :video="video"></Video>
				</Modal>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	import Video from '@/components/comm/video.vue'
	export default {
		data() {
			return {
				modal1:false,
				modal2:false,
				imgUrls:[],
				video:'https://dcloud-img.oss-cn-hangzhou.aliyuncs.com/guide/uniapp/%E7%AC%AC1%E8%AE%B2%EF%BC%88uni-app%E4%BA%A7%E5%93%81%E4%BB%8B%E7%BB%8D%EF%BC%89-%20DCloud%E5%AE%98%E6%96%B9%E8%A7%86%E9%A2%91%E6%95%99%E7%A8%8B@20181126.mp4',
				loading: false,
				total: 0,
				query: { //查询参数
					page: 0,
					size: 10,
					spomsorId: ''
				},
				modal_loading: false,
				deleteId: '',
				columns12: [{
						type: 'selection',
						width: 60,
						align: 'center'
					}, {
						title: 'id',
						key: 'id'
					},
					{
						title: '公司名称',
						key: 'advSponsor',
						render: (h, params) => {
							return h("div", params.row.platAdvSponsorName)

						}
					},
					{
						title: '广告类型',
						key: 'type',
						render: (h, params) => {
							if (params.row.type == '1') {
								return h("div", "轮播图")
							} else {
								return h("div", "短视频")
							}

						}
					},{
						title: '备注',
						key: 'remark'
					},
					{
						title: '录入人',
						key: 'advEmp',
						render: (h, params) => {
							return h("div", params.row.enteringEmpName)
						}
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}
				],
				data6: [
					/* 	{
						id: '1',
						companyName: '',
						address: '',
						phone1: '',
						phone2: '',
						phone3: '',
						mailbox: '',
						operType: '',
						state: '',
						createdTime: '2010-10-10'

					}, */
				]

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			examine(row) { //查看素材
			    console.log(row)
				switch (row.type){
					case "1"://素材为轮播图
					    this.modal1=true
						this.imgUrls=row.imgs
						break;
						
					case "2"://素材为轮播图
						this.modal2=true
						break;
					default:
						break;
				}
			},
			add() {
				this.$router.push({
					name: 'jm/adv/meaterial/add',
					query: {
						spomsorId: this.query.spomsorId
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				this.$http.post(http.url+'/plat/platAdvSponsor/material/page', this.query).then(res => {
					let data = res.data
					switch (data.code) {
						case 200:
							console.log(data)
							this.total = data.materials.totalElements
							this.data6 = data.materials.content

							this.loading = false
							break;

						case 1000:
							this.$Message.error('登陆失效，请重新登陆!');
							setTimeout(function() {
								this.$router.push('/login')
							}, 1000);
							break;
						case 100:
							this.$Message.error('服务器异常!');
							break;
						case 101:
							this.$Message.error(data.error);
							break;
						default:
							this.$Message.error('服务器异常!');
							break;
					}

				}, res => {
					this.$Message.error('系统异常请刷新后重试!');
				})
			}

		},
		components: {
			page,Video
		},
		created() {
			let spomsorId = this.$route.query.id
			this.query.spomsorId = spomsorId
			this.ajaxPage();
		}


	}
</script>
<style scoped="scoped" lang="less">
	.ivu-table-cell {
		padding-left: 0px !important;
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.ivu-table-cell {
		padding-left: 0px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}
	.lunbo{
		display: flex;
		.lunbo-img{
			width: 300px;
			height: 300px;
			margin: 20px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/adv/meaterial/list.vue